<script>
  import isConnecting from 'stores/isConnecting'
</script>

{#if $isConnecting}
  <button class='btn btn-outline-success btn-sm' type='button'>連線</button>
{:else}
  <button class='btn btn-outline-danger btn-sm' type='button'>斷線</button>
{/if}
